import React from 'react';
import Ornament from './utils/ornament';

interface Service {
  icon?: string;
  label: string;
}

interface Props {
  services?: Array<Service>;
  lineColor: string;
  iconSrc: string;
}

export default function Services({
  services,
  lineColor,
  iconSrc,
}: Props): JSX.Element {
  return (
    <section
      id="service-ctas"
      className="bg-gray-custom text-gray-alt py-12 tablet:pt-24 tablet:pb-36"
    >
      <div className="container mx-auto text-center">
        <Ornament {...{ lineColor, iconSrc }} alt={'Company Icon'} className={'mb-4'} />
        <h2 className="default--header text-magic font-bold mb-8 phablet:text-4xl tablet:mb-14 tablet:text-5xl">
          We Can Assist You With:
        </h2>
        <div className="flex flex-wrap gap-7 justify-center mx-auto">
          {services.map((service, index) => {
            return (
              <div
                className="grow-0 basis-56 shrink-0 flex justify-center items-center flex-col gap-4 capitalize px-4 py-6 xm-3 bg-white rounded-lg phablet:basis-2/5 tablet:px-0 laptop:basis-1/4 desktop:basis-64"
                key={index}
              >
                {service.icon ? (
                  <div>
                    <i
                      className={`icon-${service?.icon} text-7xl icon-color`}
                    ></i>
                  </div>
                ) : null}
                <div className="leading-7 tracking-tighter font-semibold text-[22px] tablet:w-44">
                  {service.label}
                </div>
              </div>
            );
          })}
        </div>
        <a
          className="button--primary rounded-lg inline-block font-extrabold cursor-pointer mt-[55px] mx-auto px-[44px] py-[10px] text-[22px]"
          href="#contact"
          title="Contact Us"
        >
          Contact Us
        </a>
      </div>
    </section>
  );
}
